import { Pipe, PipeTransform } from '@angular/core';
import { Observable } from 'rxjs';
import { Location } from '../classes';
import { LocationService } from '../services/location.service';

@Pipe({
  name: 'locationObject'
})
export class LocationObjectPipe implements PipeTransform {

  constructor(private _locationService: LocationService){ }

  transform(locationId: number): Observable<Location> {
    if(typeof locationId !== 'number') return null;
    return this._locationService.getLocationById(locationId, true);
  }
}
